import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 4h4v4","key":"svg-0"}],["path",{"d":"M15 9l5 -5","key":"svg-1"}],["path",{"d":"M4 20l5 -5","key":"svg-2"}],["path",{"d":"M16 20h4v-4","key":"svg-3"}],["path",{"d":"M4 4l16 16","key":"svg-4"}]]

const IconArrowsCross = createReactComponent('outline', 'arrows-cross', 'ArrowsCross', __iconNode);

export default IconArrowsCross;